import { DetailedSelectedTicketModel, OfferModel } from '../../services';
import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

import { ExperienceModel } from '@/logic/services/experiences';
import { PaymentGatewayModel } from '@/logic/services/cinemas';
import { Session } from '@/logic/services/my-booking';
import { storage } from '../../libs';

export interface BookingModel {
  sessionId: number;
  isThreeD?: boolean;
  orderId?: string;
  userSessionId?: string;
  movieId?: number;
  movieSlug?: string;
  experiences?: ExperienceModel[];
  activeExperienceTab?: number;
  activeSessions?: Session[];
  activeShowTimeTab?: number;
  maxSeats?: number;
  expireAt?: string;
  selectedTickets?: DetailedSelectedTicketModel[];
  seatsPlanImageUrl?: string;
  isLegalBookingFlow?: boolean;
  offer?: OfferModel;
  offerAreaCategories?: string[];
  prevOfferFlowLegalPath?: string;
  paymentGateway?: PaymentGatewayModel;
  cityId?: number;
  ticketDescription?: string;
}

export type BookingState = {
  booking: BookingModel | null;
  isLegalBookingFlow: boolean;
};

const initState: BookingState = {
  booking: storage.booking.get() ?? null,
  isLegalBookingFlow: false,
};

export const useBooking = createStore({
  name: 'booking-state',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setBooking: handler('booking', u => storage.booking.set(u)),
    setIsLegalBookingFlow: handler('isLegalBookingFlow'),
  };
});
